export default "__VITE_ASSET__D9Pqm$E2__"